let LanguageDirection;
(function (LanguageDirection) {
  LanguageDirection[LanguageDirection["Rtl"] = 0] = "Rtl";
  LanguageDirection[LanguageDirection["Ltr"] = 1] = "Ltr";
})(LanguageDirection || (LanguageDirection = {}));

export { LanguageDirection };
